import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../../assets/css/SignUp.css';
import CustomButton from "../../components/CustomButton";
import { useNavigate, useLocation } from "react-router-dom";
import { apiHandler } from '../../assets/api';
import { endpoint } from '../../assets/api/endpoint';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import loginImage from '../../assets/images/tennis-court.jpg';

const SignUpConfirmationCode = () => {
    const [code, setCode] = useState(["", "", "", ""]);
    const [parentOtp, setParentOtp] = useState(["", "", "", ""]);
    const [resendVisible, setResendVisible] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const email = location.state?.email;
    const guardianEmail = location?.state?.guardianEmail;

    const onConfirmationCode = async () => {
        try {
            const data = {
                OTP: code.join(""),
                emailOrMobile: email,
                guardianOTP: guardianEmail ? parentOtp.join("") : "", // Include guardian OTP only if exists
            };

            const result = await apiHandler({
                url: endpoint.SIGN_UP_OTP_VERIFY,
                method: "POST",
                data: data,
            });

            if (result.data.message) {
                toast.success(result.data.message);
                navigate("/login");
            } else {
                toast.error(result.message || 'Invalid OTP. Please try again.');
            }

        } catch (error) {
            toast.error("Something went wrong. Please try again.");
        }
    };

    const handleInputChange = (e, index, isParent = false) => {
        const value = e.target.value;
        if (!/^\d?$/.test(value)) return;

        const newCode = isParent ? [...parentOtp] : [...code];
        newCode[index] = value;
        isParent ? setParentOtp(newCode) : setCode(newCode);

        if (value && index < 3) {
            const nextId = isParent ? `parent-code-${index + 1}` : `code-${index + 1}`;
            document.getElementById(nextId)?.focus();
        }
    };

    const handleBackspace = (e, index, isParent = false) => {
        if (e.key === "Backspace" && index > 0) {
            const currentCode = isParent ? parentOtp[index] : code[index];
            if (!currentCode) {
                const prevId = isParent ? `parent-code-${index - 1}` : `code-${index - 1}`;
                document.getElementById(prevId)?.focus();
            }
        }
    };

    const onResendOTP = async () => {
        setResendVisible(false);
        try {
            const url = `${endpoint.FORGET_PASSWORD}?identifier=${email}`;
            const result = await apiHandler({ url, method: "GET" });

            if (result.data.message === "Password reset instructions sent successfully.") {
                toast.success('Reset Password Successfully');
            } else {
                toast.error(result.data.message || "Something went wrong. Please try again.");
            }
        } catch (error) {
            toast.error(error.message || "An unexpected error occurred.");
        } finally {
            setTimeout(() => setResendVisible(true), 30000);
        }
    };

    useEffect(() => {
        const timer = setTimeout(() => setResendVisible(true), 30000);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="d-flex justify-content-center align-items-center" style={{
            backgroundImage: `url(${loginImage})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            height: '100%',
            width: '100%',
            position: 'absolute',
        }}>
            <div className="border p-4 d-flex justify-content-center align-items-center" style={{ width: '407px', background: 'white', opacity: '0.9', height: guardianEmail ? '480px' : '400px' }}>
                <div style={{ width: '90%' }}>
                    <h4 className="mb-3 text-center confirmation-code-txt">Enter confirmation code</h4>
                    <p className="text-muted text-center mb-4">
                        A 4-digit code was sent to <br />
                        <strong>{email}</strong>
                    </p>
                    <div className="d-flex gap-3 justify-content-center mb-3">
                        {code.map((digit, index) => (
                            <input
                                key={index}
                                id={`code-${index}`}
                                type="text"
                                inputMode="numeric"
                                pattern="\d*"
                                maxLength="1"
                                value={digit}
                                onChange={(e) => handleInputChange(e, index)}
                                onKeyDown={(e) => handleBackspace(e, index)}
                                className="form-control text-center code-input"
                            />
                        ))}
                    </div>

                    {/* Show Parent OTP if guardianEmail is present */}
                    {guardianEmail && (
                        <>
                            <p className="text-muted text-center mb-2">
                                A 4-digit code was also sent to parent/guardian <br />
                                <strong>{guardianEmail}</strong>
                            </p>
                            <div className="d-flex gap-3 justify-content-center mb-3">
                                {parentOtp.map((digit, index) => (
                                    <input
                                        key={index}
                                        id={`parent-code-${index}`}
                                        type="text"
                                        inputMode="numeric"
                                        pattern="\d*"
                                        maxLength="1"
                                        value={digit}
                                        onChange={(e) => handleInputChange(e, index, true)}
                                        onKeyDown={(e) => handleBackspace(e, index, true)}
                                        className="form-control text-center code-input"
                                    />
                                ))}
                            </div>
                        </>
                    )}

                    {resendVisible && (
                        <div className="resend-otp-txt text-center" onClick={onResendOTP}>
                            Resend OTP
                        </div>
                    )}

                    <div className="mt-4">
                        <CustomButton
                            buttonText={'Continue'}
                            style={{
                                width: '327px',
                                height: '48px',
                                borderRadius: '12px',
                                background: '#006FFD',
                                color: '#FFFFFF',
                                border: 'none'
                            }}
                            onClick={onConfirmationCode}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SignUpConfirmationCode;
